// Google Analytics 4 call tracking: one document-level listener catches every tel: link.

declare global {
  interface Window {
    gtag?: (...args: unknown[]) => void;
  }
}

// Kept as a no-op so existing onClick props don't double-fire; the global listener handles tracking.
export const trackCallEvent = () => {};

export const initCallTracking = () => {
  if (typeof document === "undefined") return;
  document.addEventListener(
    "click",
    (e) => {
      const target = e.target as Element | null;
      const link = target?.closest?.('a[href^="tel:"]') as HTMLAnchorElement | null;
      if (!link || !window.gtag) return;
      const phone = decodeURIComponent(link.getAttribute("href")!.slice(4));
      window.gtag("event", "call", { phone_number: phone });
    },
    true
  );
};
